import React from 'react';
import { AdminView } from './AdminView';
import { NonLeafResellerView } from './NonLeafResellerView';

export const AdminAndNonLeafResellerView = (
  component: React.ReactElement | React.ReactElement[] | false
): React.ReactElement | React.ReactElement[] | false =>
  AdminView(NonLeafResellerView(component));
